var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.9999 3.67567C20.9999 5.70442 19.3541 7.35024 17.3243 7.35024C16.3567 7.35024 15.4758 6.97618 14.8192 6.36391L7.24561 10.1516C7.31353 10.4312 7.34995 10.7235 7.34995 11.0247C7.34995 11.3259 7.31353 11.6183 7.24561 11.8988L14.2058 15.3794C14.8555 14.3409 16.0091 13.6499 17.3242 13.6499C19.3539 13.6499 20.9998 15.2947 20.9998 17.3244C20.9998 19.3542 19.354 21 17.3242 21C15.3369 21 13.7177 19.4211 13.6517 17.4494L6.17969 13.7139C5.52411 14.3252 4.64313 14.7002 3.67554 14.7002C1.64583 14.7002 0 13.0544 0 11.0246C0 8.99489 1.6458 7.35006 3.67554 7.35006C4.64313 7.35006 5.52411 7.72412 6.17969 8.33639L13.7543 4.54868C13.6864 4.26912 13.6499 3.97678 13.6499 3.67557C13.6499 1.64584 15.2948 0 17.3245 0C19.3542 0 20.9999 1.64592 20.9999 3.67567Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.c075c4a44802454bf4f7592a8f645b1b.svg";
export { ForwardRef as ReactComponent };